import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { CreateExtractTasksMode } from '../../../ts/services/CreateExtractTasksAction';
import { CreateExtractRefresh } from '../AppActionTypes';
import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { ServiceLocator } from '../../ServiceLocator';
import { ContentActionNotification } from '../../../ts/services/ContentActionNotification';
import { IError } from '../../../ts/ServerApi/types/IError';
import { Messages } from '../../../codegen/Localize';

export interface CreateExtractRefreshAction extends Action {
  selectedContent: IContentInfo[];
  mode: CreateExtractTasksMode;
}

export namespace CreateExtractRefreshAction {
  function errorCodeToMessage(error: IError): string {
    switch (error.code) {
      default:
        return Messages.refreshSelfServiceScheduleUnexpectedError({ ERROR_CODE: String(error.code) });
    }
  }

  export function notifyResult(result?: IResult, isNew?: boolean) {
    const notificationService = ServiceLocator.get<ContentActionNotification>('ContentActionNotification');
    if (result && result.errors && result.errors.length) {
      const errorMessage = errorCodeToMessage(result.errors[0]);
      notificationService.notifyFailure(errorMessage);
    } else {
      const toastContent = isNew
        ? Messages.refreshSelfServiceScheduleCreateSuccess()
        : Messages.refreshSelfServiceScheduleChangeSuccess();
      notificationService.notifySuccess(toastContent);
    }
  }
}

export function createExtractRefresh(
  selectedContent: IContentInfo[],
  mode: CreateExtractTasksMode
): CreateExtractRefreshAction {
  return {
    type: CreateExtractRefresh,
    selectedContent,
    mode,
  };
}
